/** Wizetok is a standalone product — no per-exam feature checklist. */

export const PERMISSION_DENIED_MESSAGE = 'You do not have permission for that.';

function isOn(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

export function readStoredEntitlements() {
  try {
    const raw = localStorage.getItem('admin');
    const admin = raw ? JSON.parse(raw) : null;
    return admin?.entitlements || null;
  } catch {
    return null;
  }
}

export function isWizetokProductEnabled(entitlements) {
  // Backend already admitted this session. Empty entitlements (identity
  // blip / local fallback) stay open so Managers are not locked out.
  if (!entitlements || Object.keys(entitlements).length === 0) return true;
  const bucket = entitlements.wizetok;
  if (!bucket) return false;
  if (Object.prototype.hasOwnProperty.call(bucket, 'enabled')) {
    if (isOn(bucket.enabled)) return true;
    if (bucket.enabled === false || bucket.enabled === 'false' || bucket.enabled === 0 || bucket.enabled === '0') {
      return false;
    }
  }
  const features = bucket.features || {};
  return Object.values(features).some((value) => isOn(value));
}

export function examModeAllowed(_examType, entitlements = readStoredEntitlements()) {
  return isWizetokProductEnabled(entitlements);
}

export function assessmentTypeAllowed(_assessmentId, entitlements = readStoredEntitlements()) {
  return isWizetokProductEnabled(entitlements);
}
